import React from 'react'
import { Content } from './Content'

export const HightLight = () => {
  return <Content />
}
